import Banner from './Banner';

export { BannerVariant } from './enums';
export default Banner;
